import React, { Component } from "react";
import { classNames } from "../../modules/classNames";

interface LoadingProps {
    className?: string;
    alt?: string;
}

export class Loading extends Component<LoadingProps> {
    static defaultProps: LoadingProps = {
        className: "m-auto",
        alt: "Loading...",
    };

    render() {
        return (
            <div {...classNames("spinner-border", this.props.className)} role="status">
                <span className="visually-hidden">{this.props.alt}</span>
            </div>
        );
    }
}
